import {
  Button,
  Table,
  Typography,
  Popconfirm,
  InputNumber,
  Row,
  Col,
  Dropdown,
  Space,
  Input,
  Form,
  Select,
} from "antd";
import { PlusOutlined, DeleteOutlined, DownOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { useState } from "react";
import SubscriptionDropdown from "../../general/SubscriptionDropdown";

const { Text } = Typography;
const { Option, OptGroup } = Select;

const ExpenseTable = ({
  groupedProjects,
  handleGetDataByQId,
  dataSource,
  setDataSource,
  handleNewAdd,
  handleAdd,
  handleDelete,
  handleChange,
}) => {
  const columns = [
    {
      title: "SI No",
      dataIndex: "key",
      width: "7%",
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text, record) => (
        <TextArea
          allowClear
          rows={2}
          value={text}
          onChange={(e) =>
            handleChange(record.id ?? record.key, "description", e.target.value)
          }
        />
      ),
    },
    {
      title: "Qty",
      dataIndex: "qty",
      width: "10%",
      align: "center",
      render: (text, record) => (
        <InputNumber
          min={0}
          value={text}
          onChange={(value) =>
            handleChange(record.id ?? record.key, "qty", value)
          }
        />
      ),
    },

    {
      title: "Subscription",
      children: [
        {
          title: "Date",
          dataIndex: "expense_date",
          key: "expense_date",
          width: "12%",
          align: "center",
          render: (text, record) => (
            <input
              type="date"
              value={text ? text.split("T")[0] : ""}
              onChange={(e) =>
                handleChange(
                  record.id ?? record.key,
                  "expense_date",
                  e.target.value
                )
              }
              style={{
                width: "100%",
                padding: "4px",
                border: "1px solid #d9d9d9",
                borderRadius: 6,
              }}
            />
          ),
        },

        {
          title: "Subscription Type",
          dataIndex: "subscription_type",
          key: "subscription_type",
          width: "18%",
          align: "center",
          render: (text, record) => (
            <SubscriptionDropdown
              value={text}
              onChange={(val) =>
                handleChange(record.id ?? record.key, "subscription_type", val)
              }
            />
          ),
        },
      ],
    },

    {
      title: "Unit Price",
      dataIndex: "unitprice",
      width: "12%",
      align: "center",
      render: (text, record) => (
        <InputNumber
          min={0}
          value={text}
          onChange={(value) =>
            handleChange(record.id ?? record.key, "unitprice", value)
          }
        />
      ),
    },
    {
      title: "Total Price",
      dataIndex: "totalprice",
      align: "center",
      render: (text) => <Text>{text}</Text>,
      width: "10%",
    },
    {
      title: "Action",
      align: "center",
      width: 120,
      render: (_, record) => (
        <>
          <Button
            icon={<PlusOutlined />}
            type="dashed"
            size="large"
            style={{ marginRight: 8 }}
            onClick={() => handleAdd(record.id ?? record.key)}
          />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record)}
          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <Row justify="space-between" align="middle">
          <Col span={8}>
             <Form.Item layout="vertical" label="Select Project" name="project">
                <Select
                    showSearch
                    allowClear
                    placeholder="Select approved enquiry"
                    size="large"
                    onChange={handleGetDataByQId}
                    width={700}
                    optionFilterProp="children"
                >
                    {Object.keys(groupedProjects).map((qu_no) => (
                        <OptGroup key={qu_no} label={`Enquiry No: ${qu_no}`}>
                            {groupedProjects[qu_no].map((item) => (
                                <Option key={item.id} value={item.id}>
                                    {item.pro_name} ({item.department_name})
                                </Option>
                            ))}
                        </OptGroup>
                    ))}
                </Select>
            </Form.Item>
          </Col>

          <Col>
            <Button
              size="large"
              icon={<PlusOutlined />}
              type="primary"
              onClick={handleNewAdd}
              style={{ marginRight: 8 }}
            >
              Add Row
            </Button>

            <Button size="large" onClick={() => setDataSource([])}>
              Clear
            </Button>
          </Col>
        </Row>
      </div>

      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        rowKey="key"
        summary={() => {
          let totalQty = 0;
          let totalprice = 0;

          dataSource.forEach(({ qty, totalprice: rowTotal }) => {
            totalQty += qty || 0;
            totalprice += rowTotal || 0;
          });

          return (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={2}>
                <Text strong>Total</Text>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2}>
                <Text strong>{totalQty}</Text>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3}></Table.Summary.Cell>
              <Table.Summary.Cell index={4}>
                <Text strong>{totalprice}</Text>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5}></Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
      />
    </>
  );
};

export default ExpenseTable;
